/* eslint-disable jsx-a11y/control-has-associated-label */
// TODO: Add image alt tags.
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/label-has-associated-control */
import Skeleton from 'react-loading-skeleton';
import { Trans } from 'react-i18next';
import ServiceListResource from '@components/Ui/ServiceListResource';
import { ServiceData, ServiceState, singleLoad } from '@root/store/services';
import TypeIcon from '@components/Ui/Services/TypeIcon';
import { PageComponent } from '@root/pages/Type';
import ItemProccess from './ItemProccess';
import { stateToHuman } from '@components/Ui/ServiceUtils';
import styles from './Item.module.scss';
import ItemControl from './ItemControl';
import { useMediaQuery } from '@react-hook/media-query';
import classnames from 'classnames';
import useServiceEvent from '@root/utils/useServiceEvent';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@root/store/types';
import { useEffect, useState } from 'react';
import ItemMassActionHandler from './ItemMassActionHandler';

type ItemProps = {
    service: ServiceData;
};

const Item: PageComponent<ItemProps> = ({ service }) => {
    const dispatch = useDispatch<AppDispatch>();
    const [event, setEvent] = useState<number | null>(null);

    useServiceEvent(
        event,
        (_data) => {
            // console.log('service event callback');
            dispatch(singleLoad(service.orderNo));
        },
        3000,
    );

    useEffect(() => {
        if (service?.stateProccess?.event) {
            setEvent(service?.stateProccess?.event);
        } else {
            setEvent(null);
        }
    }, [service?.stateProccess?.event]);

    const matches = useMediaQuery('only screen and (max-width: 767.98px)');
    if (service.stateProccess) {
        return <ItemProccess service={service} />;
    }

    const { expireDate, isCarantine } = service;
    return (
        <div
            className={styles.service_item}
            key={`list-service-${service.orderNo}`}
        >
            <div className={styles.base}>
                <ItemMassActionHandler orderType={service.type} orderNo={service.orderNo} />
                <div className={styles.logo}>
                    {service.type ? (
                        <TypeIcon type={service.type} active />
                    ) : (
                        <Skeleton width="127" height="127" />
                    )}
                </div>
                <div className={styles.info}>
                    <h1>{service.title || <Skeleton width="60%" />}</h1>
                    <div className={styles.info_row}>
                        <h2>
                            {service.plan && service.orderNo ? (
                                <>
                                    {service.plan} ({service.orderNo})
                                </>
                            ) : (
                                <Skeleton width="60%" />
                            )}
                        </h2>
                        {service.type === 'vps' && (
                            <h3
                                className={classnames(styles.info_state, {
                                    [styles.active]:
                                        service.state == ServiceState.RUNING,
                                })}
                            >
                                <div
                                    className={classnames(styles.dot, {
                                        [styles.active]:
                                            service.state ==
                                            ServiceState.RUNING,
                                    })}
                                />
                                {stateToHuman(service) || <Skeleton />}
                            </h3>
                        )}
                    </div>
                </div>
                {!matches && (
                    <div className={styles.expire_and_control}>
                        <div className={styles.expire}>
                            <div className={styles.expire_innner}>
                                {isCarantine ? (
                                    <p className={styles.expired}>
                                        <Trans
                                            i18nKey="details.expired"
                                            ns="uiServicesMain"
                                        >
                                            Paslaugos galiojimo laikas baigėsi.
                                        </Trans>
                                    </p>
                                ) : expireDate ? (
                                    <Trans
                                        i18nKey="details.expireDate"
                                        ns="uiServicesMain"
                                        values={{ expireDate }}
                                    >
                                        Galioja iki: <span>[[expireDate]]</span>
                                    </Trans>
                                ) : (
                                    <Skeleton />
                                )}
                            </div>
                        </div>
                        <ItemControl service={service} />
                    </div>
                )}
            </div>
            <div className={styles.resources}>
                <ServiceListResource service={service} />
            </div>

            {matches && (
                <div className={styles.base}>
                    <div className={styles.expire_and_control}>
                        <div className={styles.expire}>
                            <div className={styles.expire_innner}>
                                {isCarantine ? (
                                    <p className={styles.expired}>
                                        <Trans
                                            i18nKey="details.expired"
                                            ns="uiServicesMain"
                                        >
                                            Paslaugos galiojimo laikas baigėsi.
                                        </Trans>
                                    </p>
                                ) : expireDate ? (
                                    <Trans
                                        i18nKey="details.expireDate"
                                        ns="uiServicesMain"
                                        values={{ expireDate }}
                                    >
                                        Galioja iki: <span>[[expireDate]]</span>
                                    </Trans>
                                ) : (
                                    <Skeleton />
                                )}
                            </div>
                        </div>
                        <ItemControl service={service} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Item;
